import { axiosPrivate } from "../config/axios";
import { errorApi, successApi } from "./handle.response.api";

export const createBusApi = async (tripId: string, busType: number) => {
  try {
    const res = await axiosPrivate.post(
      `/trips/bus?tripId=${tripId}&busType=${busType}`
    );
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi("Lấy chi tiết thất bại", error?.response?.data?.message);
  }
};
export const deleteBusApi = async (busId: string) => {
  try {
    const res = await axiosPrivate.delete(`/trips/bus/${busId}`);
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi("Xóa xe thất bại", error?.response?.data?.message);
  }
};

export const changeNumberBusApi = async (busId: string, busNumber: number) => {
  try {
    const res = await axiosPrivate.put(
      `/trips/bus/${busId}?busNumber=${busNumber}`
    );
    return successApi(res?.data);
  } catch (error: any) {
    console.log(error?.message);
    return errorApi("Đổi số xe thất bại", error?.response?.data?.message);
  }
};

export const addExtraSeatApi = async (
  busId: string,
  tripId: string,

  numberSeat: number
) => {
  try {
    const res = await axiosPrivate.post(
      `/trips/bus/${busId}?tripId=${tripId}&numberSeat=${numberSeat}`
    );
    return successApi(res?.data);
  } catch (error: any) {
    console.log(error?.message);
    return errorApi("Đổi số xe thất bại", error?.response?.data?.message);
  }
};
